import { render, staticRenderFns } from "./purchase-page.vue?vue&type=template&id=a66a8a4c&scoped=true"
import script from "./purchase-page.vue?vue&type=script&lang=js"
export * from "./purchase-page.vue?vue&type=script&lang=js"
import style0 from "./purchase-page.vue?vue&type=style&index=0&id=a66a8a4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66a8a4c",
  null
  
)

export default component.exports